<template>
  <div>
    <b-card
      class="question-card"
      bg-variant="light"
      :header="question.text"
      v-if="!updating"
    >
      <div class="flex-row">
        <img
          v-if="windowWidth > 560"
          :src="question.bookImage"
          alt="book-image"
          class="question-card-image"
          @click="goToBookDetail"
        />
        <div class="right-box">
          <b-card class="answer-text">
            {{ question.answer }}
          </b-card>
          <div class="q-card-middle">
            <img
              v-if="windowWidth < 560"
              :src="question.bookImage"
              alt="book-image"
              class="question-card-image my-2"
              @click="goToBookDetail"
            />
            <div>
              <b-card
                class="page-line m-2"
                v-if="question.page || question.line"
              >
                <p>p:{{ question.page }}, l:{{ question.line }}</p>
              </b-card>
              <div v-if="this.$store.getters.isSignedIn">
                <!-- 自分のカード -->
                <div
                  v-if="question.user == this.$store.getters.user.id"
                  class="flex-row"
                >
                  <b-button
                    @click="switchUpdating"
                    size="sm"
                    variant="dark m-3"
                  >
                    変更
                  </b-button>
                  <DeleteQuestionBtn
                    :bookId="question.book"
                    :questionId="question.id"
                  />
                </div>
                <!-- 他人のカード -->
                <div v-else>
                  <b-button
                    @click="addFavQuestions"
                    variant="outline-warning m-3"
                    size="sm"
                    v-if="!isFav"
                  >
                    お気に入りに登録する
                  </b-button>
                  <b-button
                    @click="removeFavQuestions"
                    variant="warning m-3"
                    size="sm"
                    v-else
                  >
                    お気に入りに登録済み
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-card bg-variant="light" v-if="question.comments" class="comment-area">
        <h5>コメント</h5>
        <b-card-text>
          <div
            class="comment-wrapper"
            v-for="(comment, index) in question.comments"
            :key="index"
          >
            {{ comment.text }}
          </div>
        </b-card-text>
      </b-card>

      <div class="flex-row card-below">
        <a :href="returnQuestionDetailUrl(question.id)" class="card-link"
          >詳しく見る</a
        >
        <b-link :href="returnUserPageUrl(question.user)" class="card-link">{{
          userData.name
        }}</b-link>
        <p class="m-3">お気に入りされた数 : {{ favCount }}</p>
      </div>
    </b-card>

    <b-card bg-variant="light" v-if="updating" class="simple-card">
      <b-row class="mt-2">
        <b-col sm="10">
          <b-form-textarea
            id="textarea-default"
            rows="3"
            placeholder="タイトルを入力してください。"
            v-model="question.text"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="10">
          <b-form-textarea
            id="textarea-default"
            rows="10"
            placeholder="内容を入力してください。"
            v-model="question.answer"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-default">ページ:</label>
        </b-col>
        <b-col sm="4">
          <b-form-input v-model="question.page" type="number"></b-form-input>
        </b-col>
        <b-col sm="2">
          <label for="textarea-default">行:</label>
        </b-col>
        <b-col sm="4">
          <b-form-input v-model="question.line" type="number"></b-form-input>
        </b-col>
      </b-row>

      <b-button
        variant="dark m-3"
        size="sm"
        @click="
          updateQuestion(
            question.id,
            question.text,
            question.answer,
            question.page,
            question.line
          )
        "
      >
        変更
      </b-button>
      <b-button variant="dark m-3" size="sm" @click="switchUpdating">
        キャンセル
      </b-button>
    </b-card>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/firebase";
import DeleteQuestionBtn from "@/components/DeleteQuestionBtn.vue";

export default {
  props: ["question"],
  data() {
    return {
      updating: false,
      isFav: this.$store.getters.isSignedIn
        ? this.$store.getters.user.favQuestions.includes(this.question.id)
        : false,
      favCount: this.question.favCount,
      userData: {},
      windowWidth: window.innerWidth
    };
  },
  components: {
    DeleteQuestionBtn
  },
  methods: {
    updateQuestion(id, text, answer, page, line) {
      this.updating = false;
      db.collection("questions")
        .doc(id)
        .update({ text: text, answer: answer, page: page, line: line })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
    },
    returnQuestionDetailUrl(id) {
      return "/question/" + id;
    },
    returnUserPageUrl(id) {
      return "/user/" + id;
    },
    goToBookDetail() {
      this.$router.push("/book/" + this.question.book);
    },
    switchUpdating() {
      if (this.updating) {
        this.updating = false;
      } else {
        this.updating = true;
      }
    },
    addFavQuestions() {
      const favQuestions = this.$store.getters.user.favQuestions;
      favQuestions.push(this.question.id);
      this.$store.dispatch("updateUserData", { favQuestions: favQuestions });
      db.collection("questions")
        .doc(this.question.id)
        .update({
          favCount: firebase.firestore.FieldValue.increment(1)
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      this.favCount++;
      this.isFav = true;
    },
    removeFavQuestions() {
      const favQuestions = this.$store.getters.user.favQuestions;
      favQuestions.forEach((questionId, index) => {
        if (questionId == this.question.id) {
          favQuestions.splice(index, 1);
        }
      });
      this.$store.dispatch("updateUserData", { favQuestions: favQuestions });
      db.collection("questions")
        .doc(this.question.id)
        .update({
          favCount: firebase.firestore.FieldValue.increment(-1)
        })
        .then(function() {
          console.log("Document successfully updated!");
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
        });
      this.favCount--;
      this.isFav = false;
    }
  },
  created() {
    db.collection("users")
      .doc(this.question.user)
      .get()
      .then(snapshot => {
        this.userData = {
          name: snapshot.data().name,
          id: snapshot.data().id
        };
      });
  }
};
</script>

<style lang="scss">
.question-card {
  margin: 20px 1.5%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
}

.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.right-box {
  width: 100%;
}

.question-card-image {
  width: 15%;
  height: auto;
  margin-right: 20px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.12), 0 2px 3px 0 rgba(0, 0, 0, 0.22);
  transition: 0.3s;
}

.question-card-image:hover {
  box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.15), 0 0 5px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.answer-text {
  white-space: pre-wrap;
  text-align: left;
}
.page-line {
  width: 25%;
  float: right;
  font-family: Courier;

  .card-body {
    padding: 0.4rem;
  }
  p {
    margin: 0 auto;
  }
}

.card-below {
  font-size: 0.7rem;
}

@media screen and (max-width: 560px) {
  .page-line {
    font-size: 0.85rem;
    width: 70%;
    float: none;
  }
  .q-card-middle {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
